

(function(){
    'use strict'

    angular
    .module('app.archivoAsociacion')
    .controller('DatosArchivoAsociacion', DatosArchivoAsociacion);

    DatosArchivoAsociacion.$inject = ['$scope', '$q', '$routeParams', '$animationsSrv', 'ArchivoAsociacionService', 'logger', '$location', 'UserInfoService', 'TiposPlanillaService', 'CalendarizacionesService', 'BloqueoXUsuarioService', 'ProcesarPlanillaService', 'PuestosService', 'DepartamentosService'];

    function DatosArchivoAsociacion($scope, $q, $routeParams, $animationsSrv, ArchivoAsociacionService, logger, $location, UserInfoService, TiposPlanillaService, CalendarizacionesService, BloqueoXUsuarioService, ProcesarPlanillaService, PuestosService, DepartamentosService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.registros = [];
        vm.tiposPlanilla = [];
        vm.puestos = [];
        vm.departamentos = [];
        vm.planillas = [];
        vm.procesoInfo = {};
        vm.title = 'DatosArchivoAsociacion';
        
        vm.pagination = {
            size: 50,
            page: 0,
            pages: 1
        };


        vm.archivoAsociacion = {
            tipoPlanillaId: -1,
            planillaId: -1,
            departamentoId: -1,
            puestoId: -1,
            nombre: '',
            identificacion: ''
        };

        vm.paramTipoPlanillaId = $routeParams.tipoPlanillaId ? $routeParams.tipoPlanillaId : -1;
        vm.paramPlanillaId = $routeParams.planillaId ? $routeParams.planillaId : -1;

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        var tiposPlanillaPromise = getTiposPlanilla();
        var procesoPromise = getProcesoInfo(vm.paramPlanillaId);
        var promisePuestos = getPuesto();
        var promiseDepartamento = getDepartamento();

        init();

        function validateTipoPlanilla(){
            if(vm.archivoAsociacion.tipoPlanillaId == -1){
                $scope.procesoArchivoAsociacionForm.tipoPlanillaId.$setValidity("different", false);
            }
            else{
                $scope.procesoArchivoAsociacionForm.tipoPlanillaId.$setValidity("different", true);
            }
        };

        function validatePlanilla(){
            if(vm.archivoAsociacion.planillaId == -1){
                $scope.procesoArchivoAsociacionForm.planillaId.$setValidity("different", false);
            }
            else{
                $scope.procesoArchivoAsociacionForm.planillaId.$setValidity("different", true);
            }
        };

        function doFormValidations(){
            validateTipoPlanilla();
            validatePlanilla();
        };

        vm.cargar = function(){

            $scope.submitted = true;
            doFormValidations();

            if(!$scope.procesoArchivoAsociacionForm.$valid){
                return;
            }

            getProcesoInfo(vm.archivoAsociacion.planillaId);
            getAll();
        };

        vm.pageMove = function(page){
            vm.pagination.page = page;
            var basePage = vm.pagination.page * vm.pagination.size;
            vm.registros = vm.dataSource.slice(basePage, (basePage + vm.pagination.size));
        };

        function getAll(){
            vm.archivoAsociacion.calendarizacionId = vm.archivoAsociacion.planillaId;
            vm.archivoAsociacion.companiaId = UserInfoService.getCompaniaId();
            
            var promise = ArchivoAsociacionService.search(vm.archivoAsociacion)
            .then(function(registros){
                vm.dataSource = registros.data;
                setPagination(vm.dataSource.length);
                vm.pageMove(0);
            })
            .catch(function(error){
                logger.warning('Los datos del archivo se estan procesando. Reintentalo más tarde.');
            }); 
            
            return promise;
        };

        function init(){
            $q.all([tiposPlanillaPromise, promisePuestos, promiseDepartamento, procesoPromise]).then(function(){
                getAllCalendarizaciones();
            });
        };

        function setPagination(recordNumber){
            vm.pagination.pages = Math.ceil(recordNumber/vm.pagination.size);
            if(vm.pagination.page == vm.pagination.pages){
                vm.pagination.page--;
            }
        };

        function getProcesoInfo(planillaId){
            var promise = ArchivoAsociacionService.getProcesoInfo(planillaId)
            .then(function(procesoInfo){
                vm.procesoInfo = procesoInfo;
            })
            .catch(function(error){
                logger.error('Error al obtener la informacion del proceso. ' + error.data.Message);
            }); 
            
            return promise;
        };

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
                vm.archivoAsociacion.tipoPlanillaId = vm.paramTipoPlanillaId;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getAllCalendarizaciones(){

            var promise = CalendarizacionesService.getAllAbiertasProcesando(UserInfoService.getCompaniaId(), vm.archivoAsociacion.tipoPlanillaId);

            promise
            .then(function(calendarizaciones){
                calendarizaciones.forEach(calendarizacion => {
                    calendarizacion.fechaInicio = moment(calendarizacion.fechaInicio).toDate();
                    calendarizacion.fechaFinal = moment(calendarizacion.fechaFinal).toDate();
                });
                vm.planillas = calendarizaciones;
                vm.archivoAsociacion.planillaId = vm.paramPlanillaId;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las Planillas.');
                        break;
                }
                
            });
        };

        function getPuesto(){
            var promise = PuestosService.getAll()
            .then(function(puestos){
                vm.puestos = puestos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        function getDepartamento(){
            var promise = DepartamentosService.getAll(UserInfoService.getCompaniaId())
            .then(function(departamentos){
                vm.departamentos = departamentos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los departamentos.');
            }); 
            
            return promise;
        };

        vm.tipoPlanillaChange = function(tipoPlanillaId){
            if(tipoPlanillaId !== -1){
                $scope.procesoArchivoAsociacionForm.tipoPlanillaId.$setValidity("different", true);
                vm.tipoPlanilla = vm.tiposPlanilla.find(function(tipo) {
                    return tipo.id == tipoPlanillaId;
                });
                getAllCalendarizaciones();          
            }
            else{
                if(tipoPlanillaId != null){
                    vm.planillas = [];
                    $scope.procesoArchivoAsociacionForm.tipoPlanillaId.$setValidity("different", false);                    
                }
            }
        };

        vm.planillaChange = function(planillaId){
            if(planillaId !== -1){
                $scope.procesoArchivoAsociacionForm.planillaId.$setValidity("different", true);
                vm.planilla = vm.planillas.find(function(p) {
                    return p.id == planillaId;
                });
            }
            else{
                if(planillaId != null){
                    $scope.procesoArchivoAsociacionForm.planillaId.$setValidity("different", false);                    
                }
            }
        };

        vm.delete = function(record){
            var promise = ArchivoAsociacionService.remove(record);
            
            promise
            .then(function(response){
                vm.dataSource = vm.dataSource.filter(function(g) {
                    return g.id !== record.id;
                });
                setPagination(vm.dataSource.length);
                vm.pageMove(vm.pagination.page);

                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        vm.update = function(record){

            $scope.submitted = true;

            if(!$scope.edicionProcesoArchivoAsociacionForm.$valid){
                return;
            }

            var promise = ArchivoAsociacionService.update(record);
            
            promise
            .then(function(response){
                record.editar = 0;
                logger.success('Registro modificado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al modificar el Registro');
                        break;
                }
                
            });   
        };
        
        vm.recalcular = function() {

            $scope.submitted = true;
            doFormValidations();

            if(!$scope.procesoArchivoAsociacionForm.$valid){
                return;
            }

            var calendarizacion = vm.planillas.find(function(c) {
                return c.id == vm.archivoAsociacion.planillaId;
            });

            if(calendarizacion.estado==1)
            {
                logger.error('La planilla debe estar en estado PROCESANDO para el recálculo');
                return;
            }

            var promise = BloqueoXUsuarioService.getBloqueoXCalendarizacion(calendarizacion.id);

            promise
            .then(function(bloqueo){
                if(bloqueo){
                    logger.warning(`La planilla esta bloqueada por: ${bloqueo.usuarioNombreCompleto}`);
                }
                else{
                    var promise = ProcesarPlanillaService.recalcular(calendarizacion);
                
                    promise
                    .then(function(response){
                        vm.goToPlanillaProcesada(calendarizacion);
                        logger.success('Planilla procesada con éxito.');
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 500:
                            logger.error(`Hubo un error al procesar la planilla: ${error.data.Message}`);
                                break;
                        
                            default:
                                logger.error('Hubo un error al procesar la planilla');
                                break;
                        }
                    }); 
                }
            })
            .catch(function(error){
                $logger.error('Error al verificar bloqueos. ');
            });
        };
        
        vm.goToPlanillaProcesada = function(calendarizacion){
            
            var path = '/planillaProcesada/';

            if(calendarizacion){

                var promise = BloqueoXUsuarioService.getBloqueoXCalendarizacion(calendarizacion.id);

                promise
                .then(function(bloqueo){
                    if(bloqueo){
                        logger.warning(`La planilla esta bloqueada por: ${bloqueo.usuarioNombreCompleto}`);
                    }
                    else{
                        $location.path(path + calendarizacion.id);
                    }
                })
                .catch(function(error){
                    $logger.error('Error al verificar bloqueos. ');
                });
            }
            else{
                logger.error('No fue posible cargar los datos de la planilla procesada');
            }
            
        };

    }
})();